<template>
    <div class="swiper"
         :class="[direction, {'dragging-swiper': dragging}]"
         @touchstart="_onTouchStart"
         @mousedown="_onTouchStart"
         >
         <!-- @wheel="_onWheel"  useless -->
        <div class="swiper-wrap"
             v-el:swiper-wrap
             :style="{'transform' : 'translate3d(' + translateX + 'px,' + translateY + 'px, 0)'}"
             @transitionend="_onTransitionEnd">
            <slot></slot>
        </div>
        <div class="swiper-pagination"
             v-show="paginationVisible">
            <span class="swiper-pagination-bullet"
                  :class="{'active': $index+1===currentPage}"
                  v-for="slide in slideEls"
                  @click="paginationClickable && setPage($index+1)"></span>
        </div>
        <button class='btn arrow arrow-left' @click="prev" v-bind:diabled="arrowClicked" v-on:dblclick="handledblClick">
          <i class='fa fa-fw fa-angle-left'></i>
        </button>
        <button class='btn arrow arrow-right' @click="next" v-bind:diabled="arrowClicked" v-on:dblclick="handledblClick">
          <i class="fa fa-fw fa-angle-right" ></i>
        </button>
    </div>
</template>
<style lang="scss">
@import '~sass/_breakpoint.scss';
@import '~__vendor_variables_scss__';

// add this class to remove arrow
.no_arrow{
  .arrow{
    display:none;
  }
}
.swiper {
  position: relative;
  overflow: hidden;
  .arrow{
    // auto disable arrows when on mobile
    @include breakpoint(xs) {
      display:none;
    }
    padding:0;
    position: absolute;
    top: 36%;
    width: 34px;
    height: 34px;
    line-height:30px;
    font-size: 30px;
    cursor:pointer;
    border-radius:50%;
    text-align:center;
    border: 1px solid $Swiper_arrow_border;
    color: $Swiper_arrow_fg;
    background-color: $Swiper_arrow_bg;
    &:focus{
      outline:none;
    }
    &:hover{
      background-color: darken($Swiper_arrow_bg, 10%);
      color: lighten($Swiper_arrow_fg, 20%);
    }
    &.arrow-left{
      left: 0;
      color: $Swiper_arrow_fg;
      .fa {
        margin-top: -4px;
        margin-left: -4px;
      }
    }
    &.arrow-right{
      right:0;
      color: $Swiper_arrow_fg;
      .fa {
        margin-top: -4px;
        margin-left: -2px;
      }
    }
  }
  .swiper-wrap {
    display: flex;
    width: 100%;
    height: 100%;
    transition: all 0.5s ease;

    > div {
      overflow: hidden;
      flex-shrink: 0;
      width: 100%;
      height: 100%;
    }
  }

  &.horizontal .swiper-wrap {
    flex-direction: row;
  }

  &.vertical .swiper-wrap {
    flex-direction: column;
  }

  &.dragging-swiper .swiper-wrap {
    transition: none;
  }

  .swiper-pagination {
    position: absolute;

    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #000000;
      opacity: .2;
      transition: all .5s ease;
    }

    .swiper-pagination-bullet.active {
      background: #007aff;
      opacity: 1;
    }
  }

  &.vertical .swiper-pagination {
    right: 10px;
    top: 50%;
    transform: translate3d(0, -50%, 0);

    .swiper-pagination-bullet {
      display: block;
      margin: 6px 0;
    }
  }

  &.horizontal .swiper-pagination {
    bottom: 10px;
    width: 100%;
    text-align: center;

    .swiper-pagination-bullet {
      display: inline-block;
      margin: 0 3px;
    }
  }
}
.__notransition {
  -webkit-transition: all 0.00005s !important;
  -moz-transition: all 0.00005s !important;
  -o-transition: all 0.00005s !important;
  transition: all 0.00005s !important;
}

</style>
<script>
const VERTICAL = 'vertical'
const HORIZONTAL = 'horizontal'

export default {
  props: {
    direction: {
      type: String,
      default: VERTICAL,
      validator: (value) => [VERTICAL, HORIZONTAL].indexOf(value) > -1
    },
    mousewheelControl: {
      type: Boolean,
      default: true
    },
    performanceMode: {
      type: Boolean,
      default: false
    },
    paginationVisible: {
      type: Boolean,
      default: false
    },
    paginationClickable: {
      type: Boolean,
      default: false
    },
    initialPage: {
      type: Number,
      default: 0
    },
    slideToPage: {
      type: Number,
      default: 0
    },
    modalShown: {
      type: Boolean,
      default: false
    },
    clicks: 0,
    transitioning: {
      type: Boolean,
      default: false,
      twoway: true
    }
  },
  data () {
    return {
      currentPage: 1,
      lastPage: 1,
      translateX: 0,
      translateY: 0,
      startTranslateX: 0,
      startTranslateY: 0,
      delta: 0,
      dragging: false,
      startPos: null,
      slideEls: [],
      disabling: false,
      arrowClicked: false
    }
  },
  ready () {
    this._onTouchMove = this._onTouchMove.bind(this)
    this._onTouchEnd = this._onTouchEnd.bind(this)
    this.slideEls = this.$els.swiperWrap.children
    let initUnWatcher = this.$watch('initialPage', (newPage) => {
      if (this.slideEls.length) {  // hold on if slideEls have not been rendered
        this._addTwoFake()
        this.setPage(newPage)
      } else {
        this.firstSetPage(newPage)
      }
      initUnWatcher()
    })
  },
  watch: {
    modalShown (nV) {
      if (nV) this.setPage(this.slideToPage)  // slide to the focused when modal shown
    },
    currentPage (nV, v) {
      if (nV > this.slideEls.length - 2) {
        this.setPage((this.slideEls.length - 2))
      } else if (nV < -1) {
        this.setPage(-1)
      }
    }
  },
  methods: {
    handledblClick () {
      this.$dispatch('alert', {
        type: 'danger',
        title: '',
        content: 'Please slow down your click.'
      })
      this.arrowClicked = true
      setTimeout(() => {
        this.arrowClicked = false
      }, 5000)
    },
    firstSetPage (toPage) {
      if (this.transitioning) return
      setTimeout(() => {
        if (this.slideEls.length) {  // waits sideEls rendering
          this._addTwoFake()
          this.setPage(toPage)
        } else {
          this.firstSetPage(toPage)
        }
      }, 1000)
    },
    next () {
      let page = this.currentPage
      this.setPage(++page)
    },
    prev () {
      let page = this.currentPage
      this.setPage(--page)
    },
    setPage (page) {
      this.transitioning = true
      let propName, translateName
      this.lastPage = this.currentPage
      this.currentPage = page

      if (this.isHorizontal()) {
        propName = 'clientWidth'
        translateName = 'translateX'
      } else {
        propName = 'clientHeight'
        translateName = 'translateY'
      }
      this[translateName] = -[].reduce.call(this.slideEls, function (total, el, i) {
        return i > page ? total : total + el[propName]
      }, 0)
      this.transitioning = false
      this._onTransitionStart()
    },
    isHorizontal () {
      return this.direction === HORIZONTAL
    },
    isVertical () {
      return this.direction === VERTICAL
    },
    _addTwoFake () {
      let head = this.slideEls[this.slideEls.length - 1].cloneNode(true)
      let tail = this.slideEls[0].cloneNode(true)
      this.$els.swiperWrap.insertBefore(head, this.slideEls[0])
      this.$els.swiperWrap.appendChild(tail)
    },
    _onTouchStart (e) {
      if (this.transitioning) return
      if (this.currentPage > this.slideEls.length - 3 || this.currentPage < 0) return // prevent this state moves
      this.startPos = this._getTouchPos(e)
      this.delta = 0
      this.startTranslateX = this.translateX
      this.startTranslateY = this.translateY
      this.startTime = new Date().getTime()
      this.dragging = true

      document.addEventListener('touchmove', this._onTouchMove, false)
      document.addEventListener('touchend', this._onTouchEnd, false)
      document.addEventListener('mousemove', this._onTouchMove, false)
      document.addEventListener('mouseup', this._onTouchEnd, false)
    },
    _onTouchMove (e) {
      if (this.transitioning) return
      this.delta = this._getTouchPos(e) - this.startPos

      if (!this.performanceMode) {
        if (this.isHorizontal()) {
          this.translateX = this.startTranslateX + this.delta
          this.$emit('slider-move', this.translateX)
        } else {
          this.translateY = this.startTranslateY + this.delta
          this.$emit('slider-move', this.translateY)
        }
      }

      // if (this.isVertical() || this.isHorizontal() && Math.abs(this.delta) > 0) {
      //   e.preventDefault()
      // }
    },
    _onTouchEnd (e) {
      this.dragging = false
      let isQuickAction = new Date().getTime() - this.startTime < 1000
      if (this.delta < -100 || (isQuickAction && this.delta < -15)) {
        this.next()
      } else if (this.delta > 100 || (isQuickAction && this.delta > 15)) {
        this.prev()
      } else {
        this._revert()
      }

      document.removeEventListener('touchmove', this._onTouchMove)
      document.removeEventListener('touchend', this._onTouchEnd)
      document.removeEventListener('mousemove', this._onTouchMove)
      document.removeEventListener('mouseup', this._onTouchEnd)
    },
    _onWheel (e) {
      if (this.mousewheelControl) {
        // Todo Support apple magic mouse and trackpad.
        if (!this.transitioning) {
          if (e.deltaY > 0) {
            this.next()
          } else {
            this.prev()
          }
        }
        if (this._isPageChanged()) e.preventDefault()
      }
    },
    _revert () {
      this.setPage(this.currentPage)
    },
    _getTouchPos (e) {
      let key = this.isHorizontal() ? 'pageX' : 'pageY'
      return e.changedTouches ? e.changedTouches[0][key] : e[key]
    },
    _onTransitionStart () {
      this.arrowClicked = true
      this.transitioning = true
      if (this._isPageChanged()) {
        this.$emit('slide-change-start', this.currentPage)
      } else {
        this.$emit('slide-revert-start', this.currentPage)
      }
      this.transitioning = false
    },
    _onTransitionEnd (e) {
      this.transitioning = true
      if (e.propertyName !== 'transform') {
        this.transitioning = false
        return
      }
      if (this._isPageChanged()) {
        if (this.currentPage === this.slideEls.length - 2) {
          this.$els.swiperWrap.classList.add('__notransition')
          this.disabling = true
          this.setPage(0)
          this.transitioning = false
          return
        }
        if (this.currentPage === -1) {
          this.$els.swiperWrap.classList.add('__notransition')
          this.disabling = true
          this.setPage(this.slideEls.length - 3)
          this.transitioning = false
          return
        }

        if (this.disabling) {
          this.disabling = false
          this.$els.swiperWrap.classList.remove('__notransition')
        }
        this.$emit('slide-change-end', this.currentPage)
      } else {
        this.$emit('slide-revert-end', this.currentPage)
      }
      this.transitioning = false
      this.arrowClicked = false
    },
    _isPageChanged () {
      return this.lastPage !== this.currentPage
    }
  }
}
</script>



// WEBPACK FOOTER //
// Swiper.vue?21314c30